import { connect } from 'react-redux'
import PatientReport from './PatientReport'
import { setInitialPatientReportData, getPatientReportData } from './module'
import { handleOnPatientBackClick } from '../../pages/PatientFile/module'

const mapActionCreators = {
  setInitialPatientReportData,
  getPatientReportData,
  handleOnPatientBackClick,
}

const mapStateToProps = state => ({
  selectedReportId: state.patientReport.selectedReportId,
  selectedPatientId: state.patientReport.selectedPatientId,
})

export default connect(
  mapStateToProps,
  mapActionCreators
)(PatientReport)



// WEBPACK FOOTER //
// ./src/legacy/pages/PatientReport/container.js